"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Slice = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var d3 = tslib_1.__importStar(require("d3"));
var Slice = (function (_super) {
    tslib_1.__extends(Slice, _super);
    function Slice(props) {
        var _this = _super.call(this, props) || this;
        _this.createAttributes = _this.createAttributes.bind(_this);
        _this.Slice = null;
        return _this;
    }
    Slice.prototype.componentDidMount = function () {
        this.createAttributes();
    };
    Slice.prototype.componentDidUpdate = function () {
        this.createAttributes();
    };
    Slice.prototype.createAttributes = function () {
        var _a = this.props, data = _a.data, color = _a.color, arc = _a.arc;
        d3.select(this.Slice).datum(data).attr('d', arc).attr('fill', color);
    };
    Slice.prototype.render = function () {
        var _this = this;
        return react_1.default.createElement("path", { ref: function (el) { return (_this.Slice = el); } });
    };
    return Slice;
}(react_1.Component));
exports.Slice = Slice;
Slice.displayName = 'FOS_DonutChartSlice';
